/* tslint:disable */
/* eslint-disable */

/**
 * 1 = Offen (Offen)
 * 
 * 2 = Abgeschlossen (Abgeschlossen)
 * 
 * 3 = Storniert (Storniert)
 * 
 * 4 = Geplant (Geplant)
 * 
 * 401130001 = Nachrichtgesendet (Nachricht gesendet)
 * 
 * 401130002 = Antwortgesendet (Antwort gesendet)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum AceNachrichtAceNachrichtEnumsAceNachrichtStatuscode {
 Offen = 1,
 Abgeschlossen = 2,
 Storniert = 3,
 Geplant = 4,
 Nachrichtgesendet = 401130001,
 Antwortgesendet = 401130002
}

marker([
    "Enum.AceNachrichtAceNachrichtEnumsAceNachrichtStatuscode.Offen",
    "Enum.AceNachrichtAceNachrichtEnumsAceNachrichtStatuscode.Abgeschlossen",
    "Enum.AceNachrichtAceNachrichtEnumsAceNachrichtStatuscode.Storniert",
    "Enum.AceNachrichtAceNachrichtEnumsAceNachrichtStatuscode.Geplant",
    "Enum.AceNachrichtAceNachrichtEnumsAceNachrichtStatuscode.Nachrichtgesendet",
    "Enum.AceNachrichtAceNachrichtEnumsAceNachrichtStatuscode.Antwortgesendet"
]);

export namespace AceNachrichtAceNachrichtEnumsAceNachrichtStatuscode
{
    class DataSets
    {
        static AceNachrichtAceNachrichtEnumsAceNachrichtStatuscodeDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Offen", 1, "Offen"),
            new EnumValue("Abgeschlossen", 2, "Abgeschlossen"),
            new EnumValue("Storniert", 3, "Storniert"),
            new EnumValue("Geplant", 4, "Geplant"),
            new EnumValue("Nachrichtgesendet", 401130001, "Nachricht gesendet"),
            new EnumValue("Antwortgesendet", 401130002, "Antwort gesendet"),
        )
    }

    export function getAsDataset() {
        return DataSets.AceNachrichtAceNachrichtEnumsAceNachrichtStatuscodeDataSet;
    }
}
